import {AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {timer} from "rxjs";

import {HOMONYM_RESIZE_DELAY} from "../../shared/defines/client.const";
import {SimpleWord} from "../../shared/models/simple-word.model";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";

@Component({
  selector: 'app-homonym-word-item',
  template: `
    <ng-container *ngIf="word">

      <app-homonym-word-disp [word]="word"
                             class="fc-green"
                             (click)="onSelectWord($event)"></app-homonym-word-disp>

      <app-homonym-word-play-btn [word]="word"></app-homonym-word-play-btn>

    </ng-container>
  `,
})
export class HomonymWordItemComponent implements AfterViewInit {
  @HostBinding('class') class = 'list-head-box';
  @Input() word?: SimpleWord;
  @Output() selectWord = new EventEmitter<string>();
  @Output() sizeOver = new EventEmitter<boolean>();
  @Output() viewInit: EventEmitter<SimpleWord> = new EventEmitter<SimpleWord>();

  constructor(
    private elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {

  }

  public ngAfterViewInit() {
    // this.sizeOver.emit(this.el.nativeElement.offsetHeight > 40);
    const el = this.elementRef.nativeElement;
    // console.log('ngAfterViewInit', el.offsetWidth, el.clientWidth, el.scrollWidth);

    if (el.clientWidth < el.scrollWidth) {
      timer(HOMONYM_RESIZE_DELAY).subscribe(() => {
        this.sizeOver.emit(true);
      });
    }

    this.viewInit.emit(this.word);
  }


  protected onSelectWord(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    if (!this.word) {
      throw new Error('HomonymWordItemComponent::onSelectWord() word is undefined');
    }
    this.selectWord.emit(this.word.id);
  }
}
